let productListingRequest;

jQuery(function ($) {
  // if this exists, should be an archive page
  const queriedObjectHolder = document.querySelector("#queried-object-id");
  // this will only be on the page when the search type is products
  const activeProductsSearch = document.querySelector(
    ".search-results__search-type.active.products"
  );

  if (queriedObjectHolder || activeProductsSearch) {
    callProductFiltering(null, true);
  }

  // handle change on attribute checkbox
  $(document).on(
    "change",
    ".archive-products__filter-checkbox",
    function (event) {
      callProductFiltering({
        value: event.target.value,
        checked: event.target.checked,
        name: event.target.name,
      });
    }
  );

  $(document).on("change", ".archive-product__orderby", function (event) {
    callProductFiltering({
      value: event.target.value,
      name: event.target.name,
    });
  });

  $(".archive-products__mobile-filters-toggle").on("click", function (e) {
    $(".archive-product__links-filter-column").toggleClass("active");
  });

  $(
    ".archive-products__mobile-filters-close, .archive-products__mobile-filters-overlay"
  ).on("click", function (e) {
    $(".archive-product__links-filter-column").removeClass("active");
  });

  $(".archive-product__clear-filters").on("click", function (event) {
    callProductFiltering({
      name: "clear-filters",
    });
  });

  $(document).on(
    "click",
    ".archive-product__pagination-button",
    function (event) {
      callProductFiltering({
        value: this.value,
        name: "page",
      });
      const mainContentContainer = document.querySelector(
        ".archive-product__main-content"
      );
      const header = document.querySelector(".header__outer");

      const yOffset = 0;
      const y =
        mainContentContainer.getBoundingClientRect().top -
        header.getBoundingClientRect().height +
        window.pageYOffset +
        yOffset;

      window.scrollTo({ top: y, behavior: "smooth" });
    }
  );

  // toggle filter list open
  const attributeFiltersWrapper = document.querySelector(
    ".archive-product__attribute-filters"
  );

  if (attributeFiltersWrapper) {
    attributeFiltersWrapper.addEventListener(
      "click",
      function (eventOnElement) {
        if (
          eventOnElement.target.matches(
            ".archive-products__filter-dropdown-button"
          )
        ) {
          const target = eventOnElement.target;
          const headingElement = target.parentNode;

          const attrList = this.querySelector(
            ".archive-products__filter-list--" + target.dataset.attr
          );

          if (attrList) {
            if (attrList.classList.contains("active")) {
              attrList.classList.remove("active");
              headingElement.classList.remove("active");
              attrList.style.maxHeight = "";
            } else {
              attrList.classList.add("active");
              headingElement.classList.add("active");
              attrList.style.maxHeight = attrList.scrollHeight + "px";
            }
          }
        }
      }
    );
  }

  if ($().selectWoo) {
    $(".archive-product__product-amount").selectWoo({
      minimumResultsForSearch: Infinity,
      debug: true,
      dir: "rtl",
      width: "100%", // need to override the changed default
    });
  }

  // handle change of amount to show
  $(".archive-product__product-amount").on("change", function (e) {
    callProductFiltering({
      value: e.target.value,
      name: "show",
    });
  });

  function callProductFiltering(filterData, initialLoad = false) {
    let searchString = location.search;

    searchString = searchString.replace(new RegExp("%5B[0-9]+%5D", "gi"), "[]");
    var queryParams = generateQueryParams(searchString, filterData);
    var string = queryParams.toString().replace("=&", "");
    if (string !== "") {
      history.pushState({}, "", location.pathname + "?" + string);
    } else if (filterData && filterData.name === "clear-filters") {
      // TODO: fix this so that it leaves the search term and type - might be fixed in prev func to this though
      history.pushState({}, "", location.pathname);
    }

    const queriedObjectHolder = document.querySelector("#queried-object-id");
    let termId;

    // TODO: better way to handle this
    // if (!queriedObjectHolder) {
    //   return;
    // }
    if (queriedObjectHolder) {
      termId = queriedObjectHolder.value;
    }

    $(".archive-products__products").block({
      message: null,
      overlayCSS: {
        background: "#fff",
        opacity: 0.6,
      },
    });
    $(".archive-product__show-wrapper").block({
      message: null,
      overlayCSS: {
        background: "#fff",
        opacity: 0.6,
      },
    });

    var data = {
      action: "product_filtering", //php function name
      object_id: termId,
      initial_load: initialLoad,
    };

    productListingRequest = $.ajax({
      type: "post",
      dataType: "json",
      url: "/wp-admin/admin-ajax.php?" + queryParams,
      data: data,
      beforeSend: function () {
        if (productListingRequest != null) {
          productListingRequest.abort();
        }
      },
      success: function (response) {
        $(".archive-products__products").unblock();
        $(".archive-product__show-wrapper").unblock();
        if (response.success === true) {
          const categoryLinksWrapper = document.querySelector(
            "#archive-product__category-links"
          );

          if (response.show_category_links === true) {
            if (categoryLinksWrapper.classList.contains("hidden")) {
              categoryLinksWrapper.classList.remove("hidden");
            }
          } else {
            if (!categoryLinksWrapper.classList.contains("hidden")) {
              categoryLinksWrapper.classList.add("hidden");
            }
          }

          const categoryLinksTitle = document.querySelector(
            "#archive-products__category-links-title"
          );
          if (response.category_link_title && categoryLinksTitle) {
            categoryLinksTitle.innerHTML = response.category_link_title;
          }

          const categoryLinks = document.querySelector(
            "#archive-product__category-link-list"
          );
          if (response.category_links && categoryLinks) {
            categoryLinks.innerHTML = response.category_links;
          }

          const attributeFilters = document.querySelector(
            ".archive-product__attribute-filters"
          );

          // if this exists, mean it is a subsequent load and just need to replace list items
          if (response.attribute_array) {
            Object.keys(response.attribute_array).forEach(function (
              attributeKey
            ) {
              const attributeClass =
                "archive-products__filter-list--" + attributeKey;
              const attributeList = document.querySelector(
                "." + attributeClass
              );
              if (attributeList) {
                attributeList.innerHTML =
                  response.attribute_array[attributeKey].list;
              } else {
                // if the attribute list doesn't currently exist in the DOM, add it
                const newAttributeTitle = document.createElement("h4");
                newAttributeTitle.classList.add(
                  "archive-products__filter-heading"
                );
                newAttributeTitle.innerHTML =
                  response.attribute_array[attributeKey].heading;

                const newAttributeList = document.createElement("ul");
                newAttributeList.classList.add("archive-products__filter-list");
                newAttributeList.classList.add(attributeClass);
                newAttributeList.innerHTML =
                  response.attribute_array[attributeKey].list;

                attributeFilters.appendChild(newAttributeTitle);
                attributeFilters.appendChild(newAttributeList);
              }
            });
            // otherwise, new load so set it all!
          } else if (response.attribute_filters && attributeFilters) {
            attributeFilters.innerHTML = response.attribute_filters;
          }

          const productsUnorderedList = document.querySelector("ul.products");
          if (response.products && productsUnorderedList) {
            productsUnorderedList.innerHTML = response.products;
          }

          const paginationContainer = document.querySelector(
            ".pagination-component"
          );
          if (response.pagination && paginationContainer) {
            paginationContainer.innerHTML = response.pagination;
          }

          const resultCountContainer = document.querySelector(
            ".woocommerce-result-count"
          );
          if (response.result_count && resultCountContainer) {
            resultCountContainer.innerHTML = response.result_count;
          }

          const initialLoadHideComponentsHelper = document.querySelector(
            ".archive-product__main-content.initial-load"
          );

          // some elements are hidden on initial load, if still hidden then show them
          if (initialLoadHideComponentsHelper) {
            initialLoadHideComponentsHelper.classList.remove("initial-load");
          }
        } else {
          console.error("Error with request", response);
        }

        if (initialLoad) {
          const activeFilters = document.querySelectorAll(
            ".archive-products__filter-list.active"
          );

          if (activeFilters && activeFilters.length) {
            activeFilters.forEach(function (activeFilter) {
              activeFilter.style.maxHeight = activeFilter.scrollHeight + "px";
            });
          }
        }
      },
      error: function (error) {
        $(".archive-products__products").unblock();
        $(".archive-product__show-wrapper").unblock();
        console.error("Error during request: ", error.responseText);
        $(".woocommerce-notices-wrapper").html(error.responseText);
      },
    });
  }
});

function generateQueryParams(search, filterData) {
  var searchParams = new URLSearchParams(search);
  var name = filterData && filterData.name ? filterData.name : "";
  var value = filterData && filterData.value ? filterData.value : "";

  const PAGE = "page";

  switch (name) {
    case "refresh":
      // Just skip past setting params
      break;
    case "clear-filters":
      const SEARCH_KEYS = ["s", "search_type"];
      searchParams.forEach(function (value, key) {
        if (!SEARCH_KEYS.includes(key)) {
          searchParams.delete(key);
        }
      });
      break;
    case PAGE:
    case "orderby":
      searchParams.set(name, value);
      break;
    case "show":
      searchParams.set(name, value);
      // if it is paged, remove due to changing show amount
      if (searchParams.has(PAGE)) {
        searchParams.delete(PAGE);
      }
      break;
    default: // I need to set something in the query string here for some reason, probably to help with clearing out any other query string params
      if (searchParams.has(name)) {
        if (searchParams.getAll(name).includes(value)) {
          // Delete param if there's only one value for that param & it's the same value as I've clicked on last time
          if (searchParams.getAll(name).length === 1) {
            searchParams.delete(name);
          } else {
            // save all current values
            var currentValues = searchParams.getAll(name);
            // delete values from current search params
            searchParams.delete(name);
            // iterate over saved values and append all to query string except
            currentValues.forEach(function (currentValue) {
              if (currentValue !== value) {
                searchParams.append(name, currentValue);
              }
            });
          }
        } else {
          searchParams.append(name, value);
        }
      } else {
        searchParams.append(name, value);
      }

      // when any of these change, need to go back to the first page so remove the page query string
      if (searchParams.has(PAGE)) {
        searchParams.delete(PAGE);
      }

      searchParams.set("", "");
      break;
  }

  // set vendor if is single shop page
  if (Array.from(searchParams.keys()).length > 1) {
    searchParams.sort();
  }

  return searchParams;
}
